import React, { useEffect, useState } from 'react';

import Heading from '../../CommonComponents/Heading/Heading';
import Description from '../../CommonComponents/Description/Description';
import Button from '../../CommonComponents/Button/Button';
import { transformWidgetProps } from '@/components/WidgetMaker/utils/common';
import { getStyleForProps } from '@/components/DesignSystem/ModernTheme/utils/getStylesConfig';

import {
  ButtonContainer,
  HeroBannerParent,
  TopSection,
  HeroBannerVideoBackground,
  BottomSection,
  BannerContainer,
} from './ModernHeroBanner3.styled.js';
import { useDispatch, useSelector } from 'react-redux';
import { toggleFormWidget } from '@/redux/actions';
import { useSSRSelector } from '@/redux/ssrStore';

function ModernHeroBanner3(props) {
  const dispatch = useDispatch();

  const { storeData } = useSSRSelector((state) => ({
    storeData: state.storeReducer.store,
  }));
  const { widgetData } = useSelector((state) => ({
    widgetData: state.widgetsReducer,
  }));
  const [heroBannerState, setHeroBannerState] = useState(
    transformWidgetProps(props?.config?.children)
  );
  const [styleConfig] = useState({
    config: {
      bannerAspectRatio: {
        desktop: 768,
        mobile: 768,
      },
      rotationSpeed: 3,
    },
  });

  useEffect(() => {
    if (props?.config?.children) {
      setHeroBannerState(transformWidgetProps(props?.config?.children));
    }
  }, [props?.config?.children]);

  useEffect(() => {
    const video = document.querySelector('video');
    if (video) {
      video.setAttribute('playsinline', '');
    }
  }, []);
  const [propStyle, setPropStyle] = useState(storeData?.theme?.style_template);

  useEffect(() => {
    if (widgetData?.activeStyleTemplate) {
      setPropStyle(getStyleForProps(widgetData?.activeStyleTemplate));
    } else {
      setPropStyle(getStyleForProps(storeData?.theme?.style_template));
    }
  }, [widgetData?.activeStyleTemplate, storeData?.theme?.style_template]);

  const openForm = () => {
    dispatch(toggleFormWidget(true));
  };

  const renderParentContainer = (bgType) => {
    return (
      <BannerContainer>
        {(heroBannerState?.heading?.text || heroBannerState?.derscription?.text) && (
          <TopSection textStyles={propStyle}>
            {heroBannerState?.heading?.text && (
              <Heading headingData={heroBannerState?.heading} />
            )}
            {heroBannerState?.description?.text && (
              <Description descriptionData={heroBannerState?.description} />
            )}
          </TopSection>
        )}

        {heroBannerState?.button && (
          <BottomSection>
            <ButtonContainer>
              {heroBannerState?.button?.content?.map((btnData, idx) => (
                <Button
                  key={btnData?.id || idx}
                  type={heroBannerState?.button?.type}
                  btnData={btnData}
                  primaryButton={propStyle?.buttonPrimary}
                  secondaryButton={propStyle?.buttonSecondary}
                  callback={openForm}
                />
              ))}
            </ButtonContainer>
          </BottomSection>
        )}
      </BannerContainer>
    );
  };
  return heroBannerState?.media?.background?.type === 'video' ||
    heroBannerState?.media?.background?.type === 'image' ? (
    <HeroBannerVideoBackground
      background={heroBannerState?.media?.background}
      className={`modern_theme_hero_banner3 bg_type_${heroBannerState?.media?.background?.type}`}
      styleConfig={styleConfig?.styleConfig}
      themeBackground={propStyle?.backgroundColor}
    >
      {' '}
      {heroBannerState?.media?.background?.type === 'video' ? (
        <video
          autoPlay
          loop
          muted
          onError={(e) =>
            (e.target.src = heroBannerState?.media?.background?.content[0]?.url)
          }
          playsInline
        >
          <source
            src={heroBannerState?.media?.background?.content[0]?.url}
            type="video/mp4"
          />
        </video>
      ) : (
        <img
          className="bg"
          src={heroBannerState?.media?.background?.content[0]?.url}
          onError={(e) =>
            (e.target.src = heroBannerState?.media?.background?.content[0]?.url)
          }
        />
      )}
      <HeroBannerParent
        id="MT__HEROBANNER3"
        styleConfig={styleConfig?.config}
        propsBackground={heroBannerState?.media?.background}
        themeBackground={propStyle?.backgroundColor}
        className={`modern_theme_hero_banner3 bg_type_${heroBannerState?.media?.background?.type}`}
      >
        {renderParentContainer('video')}
      </HeroBannerParent>
    </HeroBannerVideoBackground>
  ) : (
    <HeroBannerParent
      id="MT__HEROBANNER3"
      styleConfig={styleConfig?.config}
      propsBackground={heroBannerState?.media?.background}
      themeBackground={propStyle?.backgroundColor}
      className={`modern_theme_hero_banner3 bg_type_${heroBannerState?.media?.background?.type}`}
    >
      {renderParentContainer('')}
    </HeroBannerParent>
  );
}

export default ModernHeroBanner3;
